
import { Plan } from "@/types/subscription";

// Si aucun plan n'est récupéré, utiliser ces données de secours
export const fallbackPlans: Plan[] = [
  {
    id: "standard",
    name: "standard",
    displayName: "Basic",
    description: "Idéal pour les débutants",
    price: 0,
    priceYearly: 0,
    isPopular: false,
    features: [
      { name: "Produits Illimités", included: true },
      { name: "Landing Pages Illimitées", included: true },
      { name: "01 Thème", included: true }
    ]
  },
  {
    id: "professional",
    name: "professional",
    displayName: "Moon",
    description: "Idéal pour la plupart des entreprises",
    price: 29,
    priceYearly: 290,
    isPopular: true,
    features: [
      { name: "Fonctionnalités IA", included: true },
      { name: "+12 Thèmes", included: true },
      { name: "Variantes", included: true },
      { name: "Pixel Meta/TikTok", included: true },
      { name: "Analytique Avancée", included: true },
      { name: "Passerelle De Paiement Stripe", included: true },
      { name: "Domaine Personnalisé", included: true },
      { name: "Gestion Des SKU Et Du Stock", included: true },
      { name: "Vente Incitative Et Croisée", included: true },
      { name: "Intégrations De Sociétés De Livraison", included: true },
      { name: "Intégration Google Sheet", included: true },
      { name: "Prospects", included: false }
    ]
  },
  {
    id: "enterprise",
    name: "enterprise",
    displayName: "Stellar",
    description: "Idéal pour les vendeurs avancés",
    price: 59,
    priceYearly: 590,
    isPopular: false,
    features: [
      { name: "Toutes Les Fonctionnalités Moon", included: true },
      { name: "Plus De Fonctionnalités IA", included: true },
      { name: "Marchés Et Devises", included: true },
      { name: "Protection Contre Les Fausses Commandes", included: true },
      { name: "Importations Rapides (Youcan)", included: true },
      { name: "Google Tag Manager", included: true },
      { name: "Intégration Ecomanager", included: true },
      { name: "Panier Abandonné", included: false },
      { name: "Studio Photo IA", included: false }
    ]
  }
];
